import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconImageStyle0 = gravityIconIndividualCss;

const GravityIconImage = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '157dd14b8eb294609e5d7f6843e5cf4d9023c084', color: this.color, size: this.size }, h("svg", { key: '884e590ea18b3e481198ba7b5821045a1933d63d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '596a5546f5026dc61ceaa340c04d4f83d6434f24', d: "M12.82 10.11 10.14 14l-1.82-2.65a.24.24 0 0 0-.39 0L6 14.13a.23.23 0 0 0 .19.37h9.6a.23.23 0 0 0 .19-.37l-2.78-4a.24.24 0 0 0-.38-.02Zm-1.901-.998a1.17 1.17 0 0 1-1.089.718c-.64 0-1.16-.52-1.16-1.16a1.17 1.17 0 1 1 2.249.442Z", fill: "currentColor" }), h("path", { key: '12c8c10606137179209d0915ad11be0f18021012', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-13Zm16.5 12v-11h-15v11h15Z", fill: "currentColor" }))));
    }
};
GravityIconImage.style = GravityIconImageStyle0;

export { GravityIconImage as gravity_icon_image };

//# sourceMappingURL=gravity-icon-image.entry.js.map